var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertRewardsHub = function SvgAlertRewardsHub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 5.333H13.333V7.333H2.667V5.333Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 7.333V13.333C3.333 13.702 3.632 14 4 14H12C12.368 14 12.667 13.702 12.667 13.333V7.333",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.333V14",
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.333C8 5.333 7.4 2 5.5 2C4.672 2 4 2.672 4 3.5C4 4.5 5 5.333 6 5.333H8Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.333C8 5.333 8.6 2 10.5 2C11.328 2 12 2.672 12 3.5C12 4.5 11 5.333 10 5.333H8Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
};
export default SvgAlertRewardsHub;